import { Status as Zi } from "../../../../../common/shared/status.js";
import { Adapter as es, getAdapter as r } from "../../../api/adapter.js";
import { ScopeAdapter as is } from "../../../api/models/scope/scope.adapter.js";
import { AnalyticsAdapter as ss } from "../../../api/models/analytics/analytics.adapter.js";
import { CustomizationServiceAdapter as os } from "./services/services.adapter.js";
import { CustomizationModel as ns } from "./customization.model.js";
class _s extends es {
  adapt(e) {
    var c, l, u, p, m, _, b, y, h, t, x, k, v, f, w, F, A, B, E, C, L, S, z, P, T, M, N, D, j, I, H, O, Q, R, q, G, J, K, U, V, W, X, Y, Z, $, d, a, ee, ie, se, oe, ne, re, ge, ce, le, ue, pe, me, _e, be, ye, he, te, xe, ke, ve, fe, we, Fe, Ae, Be, Ee, Ce, Le, Se, ze, Pe, Te, Me, Ne, De, je, Ie, He, Oe, Qe, Re, qe, Ge, Je, Ke, Ue, Ve, We, Xe, Ye, Ze, $e, de, ae, ei, ii, si, oi, ni, ri, gi, ci, li, ui, pi, mi, _i, bi, yi, hi, ti, xi, ki, vi, fi, wi, Fi, Ai, Bi, Ei, Ci, Li, Si, zi, Pi, Ti, Mi, Ni, Di, ji, Ii, Hi, Oi, Qi;
    const o = r(os), n = (i) => ({
      type: i.type,
      highlight: i.highlight,
      icon: i.icon,
      text: i.text,
      content: i.content,
      texts: i.texts,
      widgetMainPage: i.widget_main_page
    }), $i = (i) => ({
      type: i.type,
      text: i.text,
      content: i.content,
      texts: i.texts
    }), di = (i) => ({
      type: i.type,
      url: i.url,
      icon: i.icon
    }), s = (i) => {
      if (i !== void 0)
        return {
          url: i.url
        };
    }, ai = (i) => {
      var Ri, qi, Gi, Ji, Ki, Ui, Vi, Wi, Xi, Yi;
      return {
        id: i.id,
        name: i.name,
        countryCode: i == null ? void 0 : i.country_code,
        services: {
          booking: (Ri = i.services) != null && Ri.booking ? o.adapt((qi = i.services) == null ? void 0 : qi.booking) : void 0,
          takeaway: (Gi = i.services) != null && Gi.takeaway ? o.adapt((Ji = i.services) == null ? void 0 : Ji.takeaway) : void 0,
          delivery: (Ki = i.services) != null && Ki.delivery ? o.adapt((Ui = i.services) == null ? void 0 : Ui.delivery) : void 0,
          deliveroo: s((Vi = i.services) == null ? void 0 : Vi.deliveroo),
          uber: s((Wi = i.services) == null ? void 0 : Wi.uber),
          glovo: s((Xi = i.services) == null ? void 0 : Xi.glovo),
          justeat: s((Yi = i.services) == null ? void 0 : Yi.justeat)
        }
      };
    }, g = (l = (c = e == null ? void 0 : e.settings) == null ? void 0 : c.configuration) == null ? void 0 : l.base_location;
    return new ns(
      e.portal_id,
      r(is).adapt(e.scope),
      {
        colors: {
          general: {
            background: ((p = (u = e == null ? void 0 : e.design) == null ? void 0 : u.colors) == null ? void 0 : p.general_background) ?? "#FFF",
            text: ((_ = (m = e == null ? void 0 : e.design) == null ? void 0 : m.colors) == null ? void 0 : _.general_text) ?? "#222",
            lines: ((y = (b = e == null ? void 0 : e.design) == null ? void 0 : b.colors) == null ? void 0 : y.general_lines) ?? "#EEE",
            highlight: ((t = (h = e == null ? void 0 : e.design) == null ? void 0 : h.colors) == null ? void 0 : t.general_highlight) ?? "#EA565C",
            highlightBackground: ((k = (x = e == null ? void 0 : e.design) == null ? void 0 : x.colors) == null ? void 0 : k.main_section_background) ?? "#242323",
            highlightText: ((f = (v = e == null ? void 0 : e.design) == null ? void 0 : v.colors) == null ? void 0 : f.main_section_text) ?? "#FFF",
            highlightErrors: ((F = (w = e == null ? void 0 : e.design) == null ? void 0 : w.colors) == null ? void 0 : F.main_section_errors) ?? "#EA565C",
            highlightLines: ((B = (A = e == null ? void 0 : e.design) == null ? void 0 : A.colors) == null ? void 0 : B.main_section_lines) ?? "#999",
            highlightHighlight: ((C = (E = e == null ? void 0 : e.design) == null ? void 0 : E.colors) == null ? void 0 : C.main_section_highlight) ?? "#EA565C",
            primaryButtonBackground: ((S = (L = e == null ? void 0 : e.design) == null ? void 0 : L.colors) == null ? void 0 : S.main_button_background) ?? "#242323",
            primaryButtonText: ((P = (z = e == null ? void 0 : e.design) == null ? void 0 : z.colors) == null ? void 0 : P.main_button_text) ?? "#FFF",
            secondaryButtonBackground: ((M = (T = e == null ? void 0 : e.design) == null ? void 0 : T.colors) == null ? void 0 : M.secondary_button_background) ?? "#BBB",
            secondaryButtonText: ((D = (N = e == null ? void 0 : e.design) == null ? void 0 : N.colors) == null ? void 0 : D.secondary_button_text) ?? "#FFF",
            userProfileBackground: ((I = (j = e == null ? void 0 : e.design) == null ? void 0 : j.colors) == null ? void 0 : I.user_profile_background) ?? "#242323"
          },
          startPage: {
            opacityLayer: (O = (H = e == null ? void 0 : e.design) == null ? void 0 : H.colors) == null ? void 0 : O.image_opacity,
            rotationalText: ((R = (Q = e == null ? void 0 : e.design) == null ? void 0 : Q.colors) == null ? void 0 : R.rotational_text) ?? "#FFF"
          }
        },
        images: {
          background: ((G = (q = e == null ? void 0 : e.design) == null ? void 0 : q.images) == null ? void 0 : G.background) ?? "https://static.cheerfy.com/static-resources/default_bg.png",
          background640x1100: (K = (J = e == null ? void 0 : e.design) == null ? void 0 : J.images) == null ? void 0 : K.background_640_1100,
          favicon: ((V = (U = e == null ? void 0 : e.design) == null ? void 0 : U.images) == null ? void 0 : V.favicon) ?? "https://static.cheerfy.com/static-resources/default_logo.png",
          logo: ((X = (W = e == null ? void 0 : e.design) == null ? void 0 : W.images) == null ? void 0 : X.logo) ?? "https://static.cheerfy.com/static-resources/default_logo.png",
          menuIcon: (Z = (Y = e == null ? void 0 : e.design) == null ? void 0 : Y.images) == null ? void 0 : Z.menu_icon
        },
        fontFamily: (($ = e == null ? void 0 : e.design) == null ? void 0 : $.font_family) ?? "QuickSand"
      },
      {
        configuration: {
          analytics: {
            google: (ee = (a = (d = e == null ? void 0 : e.settings) == null ? void 0 : d.configuration) == null ? void 0 : a.analytics) == null ? void 0 : ee.google
          },
          bodyCode: ((se = (ie = e == null ? void 0 : e.settings) == null ? void 0 : ie.configuration) == null ? void 0 : se.body_code) ?? "",
          headCode: ((ne = (oe = e == null ? void 0 : e.settings) == null ? void 0 : oe.configuration) == null ? void 0 : ne.head_code) ?? "",
          metaDescription: ((ge = (re = e == null ? void 0 : e.settings) == null ? void 0 : re.configuration) == null ? void 0 : ge.meta_description) ?? "",
          metaTitle: ((le = (ce = e == null ? void 0 : e.settings) == null ? void 0 : ce.configuration) == null ? void 0 : le.meta_title) ?? "",
          domain: ((pe = (ue = e == null ? void 0 : e.settings) == null ? void 0 : ue.configuration) == null ? void 0 : pe.domain) ?? "",
          scope: ((be = (_e = (me = e == null ? void 0 : e.settings) == null ? void 0 : me.configuration) == null ? void 0 : _e.scope) == null ? void 0 : be.map(ai)) ?? [],
          supportedLanguages: ((he = (ye = e == null ? void 0 : e.settings) == null ? void 0 : ye.configuration) == null ? void 0 : he.supported_languages) ?? [],
          baseLocation: g ? Number(g) : void 0
        },
        guest: {
          titles: ((xe = (te = e == null ? void 0 : e.settings) == null ? void 0 : te.guest) == null ? void 0 : xe.titles) ?? [],
          subtitles: ((ve = (ke = e == null ? void 0 : e.settings) == null ? void 0 : ke.guest) == null ? void 0 : ve.subtitles) ?? [],
          actions: ((Fe = (we = (fe = e == null ? void 0 : e.settings) == null ? void 0 : fe.guest) == null ? void 0 : we.actions) == null ? void 0 : Fe.map(n)) ?? [],
          text: ((Be = (Ae = e == null ? void 0 : e.settings) == null ? void 0 : Ae.guest) == null ? void 0 : Be.text) ?? {}
        },
        user: {
          titles: ((Ce = (Ee = e == null ? void 0 : e.settings) == null ? void 0 : Ee.user) == null ? void 0 : Ce.titles) ?? [],
          subtitles: ((Se = (Le = e == null ? void 0 : e.settings) == null ? void 0 : Le.user) == null ? void 0 : Se.subtitles) ?? [],
          actions: ((Te = (Pe = (ze = e == null ? void 0 : e.settings) == null ? void 0 : ze.user) == null ? void 0 : Pe.actions) == null ? void 0 : Te.map(n)) ?? [],
          text: ((Ne = (Me = e == null ? void 0 : e.settings) == null ? void 0 : Me.user) == null ? void 0 : Ne.text) ?? {},
          account: {
            actions: ((He = (Ie = (je = (De = e == null ? void 0 : e.settings) == null ? void 0 : De.user) == null ? void 0 : je.account) == null ? void 0 : Ie.actions) == null ? void 0 : He.map(n)) ?? [],
            showLink: ((Re = (Qe = (Oe = e == null ? void 0 : e.settings) == null ? void 0 : Oe.user) == null ? void 0 : Qe.account) == null ? void 0 : Re.show_link) || !1,
            text: (Je = (Ge = (qe = e == null ? void 0 : e.settings) == null ? void 0 : qe.user) == null ? void 0 : Ge.account) == null ? void 0 : Je.text
          }
        },
        menu: {
          sections: ((Ve = (Ue = (Ke = e == null ? void 0 : e.settings) == null ? void 0 : Ke.menu) == null ? void 0 : Ue.sections) == null ? void 0 : Ve.map($i)) ?? [],
          socialNetworks: ((Ye = (Xe = (We = e == null ? void 0 : e.settings) == null ? void 0 : We.menu) == null ? void 0 : Xe.social_networks) == null ? void 0 : Ye.map(di)) ?? [],
          enabled: ((($e = (Ze = e == null ? void 0 : e.settings) == null ? void 0 : Ze.menu) == null ? void 0 : $e.status) ?? Zi.ENABLED) === Zi.ENABLED,
          text: ((ae = (de = e == null ? void 0 : e.settings) == null ? void 0 : de.menu) == null ? void 0 : ae.text) ?? {}
        },
        popup: {
          showOrderEta: ((ii = (ei = e == null ? void 0 : e.settings) == null ? void 0 : ei.popup) == null ? void 0 : ii.show_order_eta) ?? !0,
          addressMandatory: ((oi = (si = e == null ? void 0 : e.settings) == null ? void 0 : si.popup) == null ? void 0 : oi.address_mandatory) ?? !1,
          addressExtraMandatory: ((ri = (ni = e == null ? void 0 : e.settings) == null ? void 0 : ni.popup) == null ? void 0 : ri.address_extra_mandatory) ?? !0,
          takeawayButton: (ci = (gi = e == null ? void 0 : e.settings) == null ? void 0 : gi.popup) == null ? void 0 : ci.take_away_button,
          deliveryButton: (ui = (li = e == null ? void 0 : e.settings) == null ? void 0 : li.popup) == null ? void 0 : ui.delivery_button,
          title: (mi = (pi = e == null ? void 0 : e.settings) == null ? void 0 : pi.popup) == null ? void 0 : mi.title,
          text: ((bi = (_i = e == null ? void 0 : e.settings) == null ? void 0 : _i.popup) == null ? void 0 : bi.text) ?? {}
        },
        cookies: {
          text: ((hi = (yi = e == null ? void 0 : e.settings) == null ? void 0 : yi.cookies) == null ? void 0 : hi.text) ?? {}
        },
        booking: {
          text: ((xi = (ti = e == null ? void 0 : e.settings) == null ? void 0 : ti.booking) == null ? void 0 : xi.text) ?? {}
        }
      },
      {
        settings: {
          legal: {
            termsAndConditions: (fi = (vi = (ki = e == null ? void 0 : e.shop) == null ? void 0 : ki.settings) == null ? void 0 : vi.legal) == null ? void 0 : fi.terms_and_conditions,
            privacyPolicy: (Ai = (Fi = (wi = e == null ? void 0 : e.shop) == null ? void 0 : wi.settings) == null ? void 0 : Fi.legal) == null ? void 0 : Ai.privacy_policy,
            cookiesPolicy: (Ci = (Ei = (Bi = e == null ? void 0 : e.shop) == null ? void 0 : Bi.settings) == null ? void 0 : Ei.legal) == null ? void 0 : Ci.cookies_policy,
            bookingPolicy: (zi = (Si = (Li = e == null ? void 0 : e.shop) == null ? void 0 : Li.settings) == null ? void 0 : Si.legal) == null ? void 0 : zi.booking_policy
          }
        }
      },
      {
        bubble: {
          iconImage: (Ti = (Pi = e == null ? void 0 : e.widget) == null ? void 0 : Pi.bubble) == null ? void 0 : Ti.icon_image,
          iconSize: (Ni = (Mi = e == null ? void 0 : e.widget) == null ? void 0 : Mi.bubble) == null ? void 0 : Ni.icon_size,
          textColor: (ji = (Di = e == null ? void 0 : e.widget) == null ? void 0 : Di.bubble) == null ? void 0 : ji.text_color,
          textSize: (Hi = (Ii = e == null ? void 0 : e.widget) == null ? void 0 : Ii.bubble) == null ? void 0 : Hi.text_size,
          text: ((Qi = (Oi = e == null ? void 0 : e.widget) == null ? void 0 : Oi.bubble) == null ? void 0 : Qi.text) ?? {}
        }
      },
      e.analytics ? r(ss).adapt(e.analytics) : void 0
    );
  }
  serialize(e) {
  }
}
export {
  _s as CustomizationAdapter
};
//# sourceMappingURL=customization.adapter.js.map
